import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {requestOrderListSuccess} from "../../store/orderList/order-list.thunks";
import {requestBetHistorySuccess, requestCasinoBetHistorySuccess} from "../../store/betHistory/bet-history.thunks";

export const connectBettingProfitAndLoseItem = (wrappedProps) => (component) => {
    function mapStateToProps(state) {
        return {
            user: state.user,
            elementsParams : state.elementsParams
        }
    }

    function mapDispatchToProps(dispatch) {
        const actions = {
            requestOrderListSuccess,
            requestBetHistorySuccess,
            requestCasinoBetHistorySuccess
        }

        return { actions: bindActionCreators(actions, dispatch) }
    }

    return connect(mapStateToProps, mapDispatchToProps)(component)
}
